import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=b7f55d18&scoped=true"
import script from "./AccordionItem.js?vue&type=script&lang=js&external"
export * from "./AccordionItem.js?vue&type=script&lang=js&external"
import style0 from "./AccordionItem.scss?vue&type=style&index=0&id=b7f55d18&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f55d18",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Title/Title.vue').default,HotIcon: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Icon/Icon.vue').default})
